import React from 'react';

const THX_RED = '#B71530';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '300px' }}>
          <div className="text-center" style={{ maxWidth: '480px' }}>
            <i className="bi bi-exclamation-triangle" style={{ fontSize: '48px', color: THX_RED }} />
            <h5 className="mt-3 mb-2" style={{ color: '#212529' }}>Something went wrong</h5>
            <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
              {this.state.error?.message || 'An unexpected error occurred on this page.'}
            </p>
            <button
              className="btn btn-sm"
              style={{ backgroundColor: THX_RED, color: '#fff', border: 'none' }}
              onClick={() => this.setState({ error: null })}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
